/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Notifications_Preferences_Category_DescriptionInputs */

const de_notifications_preferences_category_description = /** @type {(inputs: Notifications_Preferences_Category_DescriptionInputs) => LocalizedString} */ (i) => {
	if (i?.category === "infos") return /** @type {LocalizedString} */ (`TV-Tipps, Empfehlungen und hilfreiche Nutzungstipps sowie Infos zu neuen Sendern und Funktionen.`);
	if (i?.category === "offers") return /** @type {LocalizedString} */ (`Infos zu aktuellen Angeboten und Preisvorteilen von waipu.tv und zusätzlich buchbaren Streaming-Angeboten.`);
	if (i?.category === "surveys") return /** @type {LocalizedString} */ (`Gelegentliche Umfragen zur Verbesserung von waipu.tv.`);
	if (i?.category === "partners") return /** @type {LocalizedString} */ (`Infos zu Gewinnspielen und ausgewählten Partnerangeboten.`);
	return /** @type {LocalizedString} */ (``)
	
};

/** @type {(inputs: Notifications_Preferences_Category_DescriptionInputs) => LocalizedString} */
const en_notifications_preferences_category_description = de_notifications_preferences_category_description;

/**

* @param {Notifications_Preferences_Category_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_category_description = /** @type {((inputs: Notifications_Preferences_Category_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Category_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_category_description(inputs)
	return en_notifications_preferences_category_description(inputs)
});